module.exports = __webpack_public_path__ + "img/강남역 미용실 1.8bd1d77d.png";